import Lottie from 'lottie-react';

import dog08Calendar from '../jsons/Dog_08_Calendar.json';

const Dog08Calendar = props => {
  return <Lottie animationData={dog08Calendar} {...props} />;
};

export default Dog08Calendar;
